import { jsx as _jsx } from "react/jsx-runtime";
import { AddressFieldName } from '@as-react/common-types';
import { generateFieldName } from '../../../../../util/BuyFormUtil';
import { AddressFieldsBEWithValidation } from './AddressFieldsBEWithValidation';
import { AddressFieldsBEDefault } from './AddressFieldsBEDefault';
import { useFeatureToggle } from '../../../../../hooks/useFeatureToggle';
export const AddressFieldsBE = props => {
    const fieldsName = [
        AddressFieldName.ADDRESS,
        AddressFieldName.HOUSE_NUMBER,
        AddressFieldName.HOUSE_NUMBER_ADDITION,
        AddressFieldName.POSTCODE,
        AddressFieldName.CITY,
        AddressFieldName.CUSTOM_TOWN,
    ];
    const fields = fieldsName.map(name => generateFieldName(name, props.prefix));
    const bpost_address_validation = useFeatureToggle('bpost_address_validation');
    return bpost_address_validation ? (_jsx(AddressFieldsBEWithValidation, Object.assign({}, props, { fields: fields }))) : (_jsx(AddressFieldsBEDefault, Object.assign({}, props, { fields: fields })));
};
